/* Alerts */
export const SET_ALERT = '__setAlert'
export const SET_ALERT_SHOW = '__setAlertShow'
export const CLEAR_ALERT = '__clearAlert'
export const SET_DIALOG = '__setDialog'
export const SET_DIALOG_SHOW = '__setDialogShow'
export const CLEAR_DIALOG = '__clearDialog'

export default {
  SET_ALERT,
  SET_ALERT_SHOW,
  CLEAR_ALERT,
  SET_DIALOG,
  SET_DIALOG_SHOW,
  CLEAR_DIALOG
}
